module.exports = __webpack_public_path__ + "img/upstage_logo_only.40c1b775.png";